import { createI18n } from 'vue-i18n' // 引入i18n创建多语言对象
import zhLocale from './zh-CN'; // 引入中文对应语言配置
import enLocale from './en-US'; // 引入英文对应语言配置

const messages = {
    'zh-CN': zhLocale,
    'en-US': enLocale
}

const localLang = navigator.language.split('-')[0]; // 获取浏览器语言环境
const storageLang = window.localStorage.getItem('lang') || 'en'; // 获取localStorage本地语言环境
const c = (storageLang.toLocaleLowerCase() !== 'zh-cn' && storageLang.toLocaleLowerCase() !== 'en-us') ? 'en-us' : storageLang; // 如果localStorage语言环境既不是中文也不是英文就取为英文

const i18n = createI18n({
    globalInjection: true, // 开启全局多语言渗透
    locale: c || localLang || 'en-US', // 语言环境
    messages, // 语言配置字段
    legacy: false, // // 使用 vue3 组合式API 时必须设置为 false
})

export default i18n
